<script setup lang="ts">
import { propTypes } from '@/utils/propTypes'
import { computed, unref } from 'vue'
import { useRouter } from 'vue-router'
import { useUserStore } from '@/store/modules/user'

const { currentRoute } = useRouter()
const userStore = useUserStore()

const props = defineProps({
  permission: propTypes.string.def()
})

const currentPermission = computed(() => {
  return unref(currentRoute)?.meta?.permission || userStore.getUserInfo?.permissions || []
})

const hasPermission = computed(() => {
  const permission = unref(props.permission)
  if (!permission || unref(currentPermission).includes('*:*:*')) {
    return true
  }
  return unref(currentPermission).includes(permission)
})
</script>

<template>
  <template v-if="hasPermission">
    <slot></slot>
  </template>
</template>
